import { AppBar, Box, Button, Container, Toolbar, Typography, Avatar, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Divider, Drawer, Card, CardMedia, Dialog, DialogContent, DialogActions, MenuItem, Menu, IconButton, Collapse } from '@mui/material';
import { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import jwt_decode from "jwt-decode";
import { useDataContext } from '../contexts/dataContext';
import AssignmentIndTwoToneIcon from '@mui/icons-material/AssignmentIndTwoTone';
import FlakyTwoToneIcon from '@mui/icons-material/FlakyTwoTone';
import EventTwoToneIcon from '@mui/icons-material/EventTwoTone';
import PaidTwoToneIcon from '@mui/icons-material/PaidTwoTone';
import StyleTwoToneIcon from '@mui/icons-material/StyleTwoTone';
import FeedbackTwoToneIcon from '@mui/icons-material/FeedbackTwoTone';
import QuestionAnswerTwoToneIcon from '@mui/icons-material/QuestionAnswerTwoTone';
import AddTaskTwoToneIcon from '@mui/icons-material/AddTaskTwoTone';
import PriceCheckTwoToneIcon from '@mui/icons-material/PriceCheckTwoTone';
import CalculateTwoTone from '@mui/icons-material/CalculateTwoTone';
import FolderCopyTwoToneIcon from '@mui/icons-material/FolderCopyTwoTone';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

export default function Navegacion() {
    const { usuario, esAsistente, setEsAsistente, esJefe, setEsJefe, setUsuario, /*planPresupuestalContexto,*/ openAvisos, setOpenAvisos } = useDataContext()

    const [state, setState] = useState({
        left: false,
    });

    const [anchorElNav, setAnchorElNav] = useState(null);
    const [openPlaneacion, setOpenPlaneacion] = useState(true);
    const [openGestion, setOpenGestion] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClickInfografias = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };


    const handleClick = (event) => {
        event.stopPropagation();
        setOpenPlaneacion(!openPlaneacion);
    };
    const handleClickGestion = (event) => {
        event.stopPropagation();
        setOpenGestion(!openGestion);
    };

    const token = sessionStorage.getItem('token')
    let idResponsable = null
    let idEntidad = null

    if (token) {
        const decoded = jwt_decode(token);
        idResponsable = decoded.id
        idEntidad = sessionStorage.getItem('idEntidad')


    }
    const obtenerReglas = (decoded) => {
        let reglas
        const perfilElegido = sessionStorage.getItem('perfilElegido')
        switch (perfilElegido) {
            case 'asistente':
                reglas = decoded.rulesAsistente
                break
            case 'investigador':
                reglas = decoded.rulesJefaturaArea
                break
            case 'coordinacion':
                reglas = decoded.rulesCoordinacion
                break
            case 'jefe':
                reglas = decoded.rulesJefatura
                break
            case 'administracion':
                reglas = decoded.rulesAdministracionProyecto
                break
            default:
                break
        }
        return reglas
    }
    useEffect(() => {
        (async () => {
            if (token) {
                const decoded = jwt_decode(token);
                let reglas = decoded.rules
                if (!reglas)
                    reglas = obtenerReglas(decoded)
                const idResponsable = decoded.id;
                const resUsuario = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/usuarios/${idResponsable}`)
                const data = await resUsuario.json()
                setUsuario(data)
                for (let i = 0; i < reglas.length; i++) {
                    console.log(`REGLA ${i} action ${reglas[i].action} subject ${reglas[i].subject}`)
                    if (reglas[i].action === 'manage' && reglas[i].subject === 'planPresupuestal') {
                        setEsJefe(true)
                        return
                    }
                    if (reglas[i].action === 'asistente' && reglas[i].subject === 'division') {
                        setEsAsistente(true)
                        return
                    }
                }
            }
        })();
    }, []);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };



    const navigate = useNavigate()

    return (
        <>
            <Box style={{ flexGrow: 1 }}>
                <AppBar position='sticky' color='primary' >
                    <Container maxWidth="xl">
                        <Toolbar disableGutters>
                            <Typography variant='h5' style={{ flexGrow: 1 }}>
                                NADU 2
                            </Typography>
                            {/*token ?
                                <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                                    <IconButton
                                        size="large"
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        aria-haspopup="true"
                                        onClick={handleOpenNavMenu}
                                        color="inherit"
                                    >
                                        <MenuIcon />
                                    </IconButton>
                                    <Menu
                                        id="menu-appbar"
                                        anchorEl={anchorElNav}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        open={Boolean(anchorElNav)}
                                        onClose={handleCloseNavMenu}
                                        sx={{
                                            display: { xs: 'block', md: 'none' },
                                        }}
                                    >
                                        <MenuItem key={'logout'} onClick={handleCloseNavMenu}>
                                            {token ? (
                                                <Button variant='outlined' color='inherit' onClick={() => { sessionStorage.clear(); setEsAsistente(false); setEsJefe(false); navigate("/auth/login"); }} style={{ display: (token ? 'block' : 'none'), width: '100%' }}>Logout</Button>) : (<></>)}
                                        </MenuItem>
                                    </Menu>
                                </Box>
                                : <></>*/}

                            <Box sx={{ flexGrow: 'revert', display: { xs: 'flex', md: 'flex' } }}>
                                <div>
                                    <Button
                                        variant='outlined' color='inherit'
                                        style={{ marginRight: '20px', height:'100%' }}
                                        id="basic-button"
                                        aria-controls={open ? 'basic-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={open ? 'true' : undefined}
                                        onClick={handleClickInfografias}
                                    >
                                        Infografías
                                    </Button>
                                    <Menu
                                        id="basic-menu"
                                        anchorEl={anchorEl}
                                        open={open}
                                        onClose={handleClose}
                                        MenuListProps={{
                                            'aria-labelledby': 'basic-button',
                                        }}
                                    >
                                        <MenuItem onClick={() => { window.open("/images/infografias/Infografia-crear-actualizar-contrasena.pdf"); }}>Crear / actualizar contraseña</MenuItem>
                                        <MenuItem onClick={() => { window.open("/images/infografias/Infografia-registro-alumno-nuevo-ingreso.pdf"); }}>Registrarse como alumno de nuevo ingreso</MenuItem>
                                    </Menu>
                                </div>
                                {token ? <>
                                    <Button variant='outlined' color='inherit' onClick={() => { sessionStorage.clear(); setEsAsistente(false); setEsJefe(false); navigate("/auth/login"); }} style={{ display: (token ? 'block' : 'none'), marginRight: 20 }}>Cerrar sesión</Button>
                                </> : <></>
                                }

                            </Box>

                            <Avatar alt="UAM-L" src="/images/UAML.png" />
                        </Toolbar>
                    </Container>
                </AppBar>
            </Box>

        </>
    )
}